import { useCompactMode } from './useCompactMode';
import { formatCurrency as formatCurrencyHelper, formatCurrencyReadable as formatCurrencyReadableHelper } from '../utils/helpers';

/**
 * Hook that returns formatting functions with compact mode automatically applied.
 * Use this in components that display currency values.
 * Do NOT use this in export helpers — those should always use the raw formatCurrency from helpers.ts.
 */
export const useFormatCurrency = () => {
    const { compactMode } = useCompactMode();

    const formatCurrency = (amount: number): string => {
        return formatCurrencyHelper(amount, compactMode);
    };

    const formatCurrencyReadable = (amount: number, locale?: string): string => {
        return formatCurrencyReadableHelper(amount, locale, compactMode);
    };

    return { formatCurrency, formatCurrencyReadable, compactMode };
};
